import React, { FunctionComponent } from 'react'
import { StyleSheet, Text, View, TextInput } from 'react-native';
import Collapsible from 'react-native-collapsible';
import MyCheckbox from '../MyCheckbox';
import MyPicker from '../MyPicker';
import MyText from '../MyText';
import MyTextarea from '../MyTextarea';
import MyTextInput from '../MyTextInput';
import css from '../Style'

const PersonsOnBoard = (props) => {
    const [total, setTotal] = React.useState('');
    const [crew, setCrew] = React.useState('');
    const [passengers, setPassengers] = React.useState('');

    React.useEffect(() => {
        props.onChange({
            total,
            crew,
            passengers
        });
    }, [total, crew, passengers]);

    return (
        <View style={styles.externalContainer}>
            <MyText style={[css.m, styles.title]}>
                Number of Persons onboard
            </MyText>
            <View style={styles.container}>
                <View style={[{zIndex: 10}, css.formRow]}>
                    <MyText style={css.formRowLabel}>
                        Total
                    </MyText>
                    <MyTextInput
                        inputMode='decimal'
                        keyboardType='phone-pad'
                        style={[{flexGrow: 1, flexShrink: 0, marginRight: 5}, css.formRowInput]}
                        onChangeText={setTotal}
                        value={total}
                    />
                </View>
                <View style={[{zIndex: 9}, css.formRow]}>
                    <MyText style={css.formRowLabel}>
                        Crew Members
                    </MyText>
                    <MyTextInput
                        inputMode='decimal'
                        keyboardType='phone-pad'
                        style={[{flexGrow: 1, flexShrink: 0, marginRight: 5}, css.formRowInput]}
                        onChangeText={setCrew}
                        value={crew}
                    />
                </View>
                <View style={[{zIndex: 9}, css.formRow]}>
                    <MyText style={css.formRowLabel}>
                        Passengers
                    </MyText>
                    <MyTextInput
                        inputMode='decimal'
                        keyboardType='phone-pad'
                        style={[{flexGrow: 1, flexShrink: 0, marginRight: 5}, css.formRowInput]}
                        onChangeText={setPassengers}
                        value={passengers}
                    />
                </View>
            </View>
        </View>
    )
}
const styles = StyleSheet.create({
    externalContainer: {
        // paddingBottom: 10,
        // borderColor: '#532b75',
        // borderWidth: 1,
        // borderRadius: 20,
        // marginBottom: 15,
        flex: 1
    },
    container: {
        // paddingVertical: 10,
        // paddingHorizontal: 20,
        // paddingBottom: 0,
        // flex: 1
    },
    title: {
        color: '#461b6f',
        paddingVertical: 15,
        // paddingHorizontal: 20,
        // borderColor: '#461b6f',
        // borderBottomWidth: 1,
        // width: '60%'
    },
})
export default PersonsOnBoard